// extracted by mini-css-extract-plugin
module.exports = {"spinnerContainer":"az_Ip","spin":"az_Jp","spinnerWrapper":"az_Kp","spinner":"az_Lp"};